<template lang="pug">
  .configuration-lesson
    .text-h6.mb-3 Параметры урока
    validation-provider(
      rules="required"
      name="Название урока"
      v-slot="{ errors, valid }"
    )
      v-textarea(
        :value="value.name"
        name="name"
        auto-grow
        rows="2"
        row-height="20"
        label="Название урока"
        :error-messages="errors"
        filled
        rounded
        @input="update('name', $event)"
      )
    validation-provider(
      name="Описание урока"
      v-slot="{ errors, valid }"
    )
      v-textarea(
        :value="value.description"
        name="description"
        label="Описание урока"
        :error-messages="errors"
        filled
        rounded
        @input="update('description', $event)"
      )
    validation-provider(
      rules="required"
      name="Тип урока"
      v-slot="{ errors, valid }"
    )
      v-select(
        :value="value.type"
        name="type"
        label="Тип урока"
        :items="lessonResources.type"
        item-text="title"
        item-value="value"
        :error-messages="errors"
        filled
        rounded
        @input="update('type', $event)"
      )
</template>

<script>
import { format, add } from 'date-fns';
import { mapGetters } from 'vuex';

import IntegerInput from '@/components/InputFields/IntegerInput.vue';

import { LESSON_TYPES } from '@/utils/constants';

const DATE_FORMAT = 'yyyy-MM-dd HH:mm';

export default {
  components: {
    IntegerInput,
  },
  props: {
    value: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      dateStart: this.value.date_start,
      startImmediately: false,

      LESSON_TYPES,
    };
  },
  computed: {
    ...mapGetters(['lessonResources']),
    duration() {
      return this.value.duration;
    },
  },
  watch: {
    dateStart(val) {
      if (val instanceof Date) {
        this.setDates();
      }
    },
    duration(val) {
      if (val) this.setDates();
    },
    startImmediately(val) {
      this.update('start_immediately', val);
    },
  },
  created() {
    this.$store.dispatch('GET_RESOURCES');
  },
  methods: {
    setDates() {
      if (this.dateStart) {
        this.update('date_start', format(this.dateStart, DATE_FORMAT));
        this.$nextTick(() => {
          this.update('date_end', format(add(this.dateStart, { minutes: this.duration }), DATE_FORMAT));
        });
      }
    },
    update(key, val) {
      this.$emit('input', { ...this.value, [key]: val });
    },
  },
};
</script>
